import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import ReactSVG from 'react-svg';

import UpdateVehicleContainer from '@containers/vehicle/crud/UpdateVehicleContainer';

import Collapsible from '@uicomponents/Collapsible';
import Loader from '@uicomponents/Loader';

import NotesView from '../note/NotesView';

class VehicleView extends Component {
  render() {
    const { t, vehicle, isFetchingVehicle, onChange, addToStack } = this.props;

    if (!vehicle || isFetchingVehicle) {
      return <Loader />;
    }
    return (
      <div className="vehicle-view">
        <div className="flex-container justify-between no-wrap">
          <div>
            <div className="flex-container justify-between">
              <h1 className="no-margin">{vehicle.name}</h1>
            </div>
            <h3 className="no-margin-top">#{vehicle.id}</h3>
          </div>
          <div className="self-center flex-container action-icons">
            <div
              className="action-icon"
              onClick={(e) => {
                e.preventDefault();
                addToStack({
                  name: t('vehicle.update.header'),
                  component: (
                    <UpdateVehicleContainer
                      targetVehicle={{ ...vehicle }}
                      callback={(result) => {
                        onChange('vehicle', result.vehicle || {});
                      }}
                    />
                  ),
                });
              }}
            >
              <ReactSVG src="/icons/pencil.svg" />
            </div>
          </div>
        </div>

        <div>
          <b>{t('vehicle.type')}</b>: {t(`vehicleType.${vehicle.vehicleType}`)}
        </div>
        {vehicle.fuelType && (
          <div>
            <b>{t('vehicle.fuelType')}</b>: {vehicle.fuelType}
          </div>
        )}
        {vehicle.emissionsClass && (
          <div>
            <b>{t('vehicle.emissionsClass')}</b>: {vehicle.emissionsClass}
          </div>
        )}
        {vehicle.description && (
          <div>
            <b>{t('vehicle.description')}</b>: {vehicle.description}
          </div>
        )}
        {vehicle.vin && (
          <div>
            <b>{t('vehicle.vin')}</b>: {vehicle.vin}
          </div>
        )}
        {vehicle.licensePlate && (
          <div>
            <b>{t('vehicle.licensePlate')}</b>: {vehicle.licensePlate}
          </div>
        )}
        {vehicle.maxLinks && (
          <div>
            <b>{t('vehicle.maxLinks')}</b>: {vehicle.maxLinks}
          </div>
        )}
        {vehicle.emptyWeight && (
          <div>
            <b>{t('vehicle.emptyWeight')}</b>:{' '}
            {`${vehicle.emptyWeight.value} ${vehicle.emptyWeight.unit}`}
          </div>
        )}
        {vehicle.width && vehicle.length && vehicle.height && (
          <div>
            <b>{t('vehicle.dimensions')}</b>:{' '}
            {`${vehicle.length.value} x ${vehicle.height.value} x ${vehicle.width.value} ${vehicle.width.unit}`}
          </div>
        )}
        {vehicle.loadCapacities &&
          vehicle.loadCapacities.map((loadCapacity, index) => (
            <div>
              <b>
                {t('vehicle.loadCapacity')} #{index + 1}
              </b>
              : {`${loadCapacity.value} ${loadCapacity.unit}`}
            </div>
          ))}
        <Collapsible
          name={`${t('notes.header')}${
            vehicle.notes && vehicle.notes.length > 0
              ? ` (${vehicle.notes.length})`
              : ''
          }`}
          className="collapsible-element"
          defaultIsOpen={false}
        >
          <NotesView notes={vehicle.notes} />
        </Collapsible>
      </div>
    );
  }
}
export default withTranslation('translation')(VehicleView);
